const sizes = {
  SMALL_SCREEN: '1024px',
  IPAD: '768px',
  MOBILE_LARGE: '640px',
  MOBILE: '480px',
  MOBILE_SMALL: '390px',
};

export default sizes;
